import axiosInstance from "./axiosInstance";

export interface PropertyGradeApi {
  publicId: string;
  name: string; 
  code: string;
  createdAt: string;
  isActive: boolean;
}

export interface PropertyGradeListResponse {
  items: PropertyGradeApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface CreatePropertyGradePayload {
  name: string;
  code: string;
  isActive: boolean;
}

export interface UpdatePropertyGradePayload {
  publicId: string;
  name: string;
  code: string;
  isActive: boolean;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getPropertyGrades = async (params: {
  searchText?: string | null;
  pageNo: number;
  pageSize: number;
}): Promise<PropertyGradeListResponse> => {
  const res = await axiosInstance.get("/property-grades/list", {
    headers: getAuthHeader(),
    params
  });

  return res.data;
};

export const createPropertyGrade = async (
  payload: CreatePropertyGradePayload
) => {
  const res = await axiosInstance.post("/property-grades", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updatePropertyGrade = async (
  payload: UpdatePropertyGradePayload
) => {
  const res = await axiosInstance.put("/property-grades", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const deletePropertyGrade = async (publicId: string) => {
  const res = await axiosInstance.delete(`/property-grades/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};